import { local } from "d3";

function redirectToMainPage(next) {
  // You can display a notification here if needed
    localStorage.removeItem('token')
    return next({path: '/'});
}

/**
 * Middleware to check if user has the correct right to access a certain page.
 * Checks are performed based on route meta fields `meta: { requiresAuth: true }`.
 * @param {object} router Vue router instance
 */
export default function authMiddleware(router) {
    router.beforeEach(async (to, from, next) => {
        // check for the routes that have `requiresAuth: true`
        let requiresAuth = to.matched.some(record => record.meta.requiresAuth);
        if (!requiresAuth) {
            return next();
        }
        if(localStorage.getItem('token') == null) {
            redirectToMainPage(next);
        }
        const params = new URLSearchParams();
        params.append('token', localStorage.getItem('token'));
        const response = await fetch('https://crm-api.solana-eliquides.fr/login', {
            method: 'POST',
            credentials: 'include',
            body: params
        });
        const json = await response.json();
        //check if api return regenerated token
        if(json.message.hasOwnProperty('id') && json.message.hasOwnProperty('token')) {
            localStorage.setItem('token', json.message.token)
            return next();  
        } else {
            redirectToMainPage(next);
        }
    })
}